{
  "buttons": {
    "newAudience": "New Audience"
  },
  "confirmations": {
    "delete": {
      "title": "Delete Audience",
      "description": "Are you sure? You can't undo this action afterwards.",
      "buttonConfirmation": "Delete"
    }
  }
}
